import {getDrops} from "../../api.js";
import React, {useCallback, useContext, useEffect, useState} from "react";
import {Pagination} from "../../shared/Pagination.jsx";
import {useNavigate} from "react-router-dom";
import {Box, Grid} from "@mui/material";
import {UserContext} from "../../shared/Greet.jsx";
import {formatDate} from "../../services/utils.js";
import {Loading} from "../../shared/Loading.jsx";

export const DropsList = () => {

  const navigate = useNavigate()

  const { user } = useContext(UserContext)

  const [loading, setLoading] = useState(false)

  const [drops, setDrops] = useState([])
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [pagination, setPagination] = useState({})

  const updateDropsList = useCallback(({limit, offset}) => {
    if(user.user_id){
      getDrops({limit, offset, userId: user.user_id}).then(({drops, pagination}) => {
        setDrops(drops)
        setPagination(pagination)
      })
    }
  }, [user])

  useEffect(() => {
    if (user.user_id) {
      updateDropsList({ limit, offset });
    }
  }, [user, limit, offset, updateDropsList]);

  const goToDrop = (id) => {
    navigate(`/drop/${id}`)
  }

  return <Box component="form" sx={{ maxWidth: 600, margin: 'auto', padding: 2, bgColor: "fff" }}>
    <Grid container spacing={2}>
      <div style={{width: "100%"}}>
        <h2>Список Дропов</h2>

        {loading && <Loading />}

        <div>
          {drops?.length ?
              <Pagination pagination={pagination} onChange={updateDropsList} limit={limit} offset={offset}
                          setLimit={setLimit}
                          setOffset={setOffset}>
                <table className="drops-list">
                  <thead>
                  <tr>
                    <th>Продукт</th>
                    <th>Количество</th>
                    <th>Коммент</th>
                    <th>Тип</th>
                    <th>Дата Создания</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  {drops.map((drop) => {
                    return <tr key={drop.id} className="border-2 cursor-pointer">
                      <td>
                        <span>{drop.productTitle}</span>
                      </td>
                      <td>
                        {drop.packageQuantity}
                      </td>
                      <td>
                        {drop.comment}
                      </td>
                      <td>
                        {drop.dropType === 'magnet' ? '🧲' : '-'}
                      </td>
                      <td>
                        {formatDate(drop.createdAt)}
                      </td>
                      <td>
                        <button onClick={() => goToDrop(drop.id)}>
                          Manage
                        </button>
                      </td>
                    </tr>
                  })}
                  </tbody>
                </table>
              </Pagination> : <div className="mt-5">
                Кладов не найдено
              </div>}

      </div>
      </div>
    </Grid>
  </Box>
}
